<template>
	<div>
		<template v-if="isLaptop">
			<b-modal
				id="Profilesmodal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				v-model="showModal"
				@hidden="$emit('close-modal')"
			>
				<div style="min-height: 380px">
					<div class="candash-modal-top p-3">
						<div class="candash-modal-head">Profiles</div>

						<div class="d-flex align-items-center">
							<div
								class="d-flex align-items-center mb-resume-name pointer"
								@click="createNewProfile()"
								ref="openDownloadDiv2"
							>
								<img
									class="mr-1"
									src="../../assets/New Profile/create-resume.svg"
									alt=""
								/>

								Create New Profile
							</div>
							<div class="asp-vertical-line mx-4"></div>
							<img
								@click="$emit('close-modal')"
								class="rotate-on-hover pointer"
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</div>

					<div class="profilesmodal-body">
						<div class="mb-black-bold">Currently In</div>
						<div class="currentlyin-cont mt-1">
							<div class="mb-resume-name d-flex align-items-center">
								<img
									class="mr-2"
									src="../../assets/New Profile/viewAll-resume-icon.svg"
									alt=""
								/>{{ candidateInfo.profileName }}
							</div>
							<div class="d-flex align-items-center">
								<div v-if="candidateInfo.draft" class="draft-box mr-2">
									Draft
								</div>
								<div
									v-if="candidateInfo.draft"
									class="asp-vertical-line mx-3"
								></div>
								<img
									v-if="!candidateInfo.primary"
									class="pointer"
									@click.stop="
										$bvModal.show('deleteresume_1'),
											setProfileData(
												candidateInfo.profileName,
												candidateInfo._id
											)
									"
									v-b-tooltip.hover="'Delete'"
									src="../../assets/img/deleteprofile.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-end mt-2">
							<!-- <div
								@click="checkGraphicalResumeDownload()"
								class="asp-small-grey-txt-2 d-flex align-items-center pointer"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/dashboard/downGraph.svg"
									alt=""
								/>Download Graphical Resume
							</div>
							<div class="asp-vertical-line"></div> -->
							<div
								@click="openDownloadForm()"
								class="asp-small-grey-txt-2 d-flex align-items-center pointer"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/dashboard/downAts.svg"
									alt=""
								/>Download ATS Resume
							</div>
							<div
								v-if="candidateInfo.primary == false"
								class="asp-vertical-line"
							></div>
							<div
								v-if="candidateInfo.primary == false"
								class="asp-small-grey-txt-2 d-flex align-items-center pointer"
								@click="
									(mobCreateNewProfile = false),
										(showCreateNewMProfileModal = false),
										changeProfile(candidateInfo.primaryID)
								"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/dashboard/switchTo.svg"
									alt=""
								/>Switch to Primary Profile
							</div>
						</div>
						<hr class="hr-background" />
						<div>
							<div class="mb-black-bold">All Profiles</div>
							<div class="position-relative mt-1">
								<img
									class="resumes-search-image-position-2"
									src="../../assets/newdesign/assessPro/magni.svg"
									alt=""
								/>
								<b-form-input
									debounce="500"
									@update="getAllProfiles"
									v-model.trim="searchQuery"
									class="resumes-search-input w-100"
									placeholder="Search Profiles"
									type="search"
								>
								</b-form-input>
							</div>
							<div
								style="position: relative; top: 50px"
								v-if="showProfileListLoader"
								class="d-flex justify-content-center align-items-center h-100"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>
							<div
								v-else-if="allProfileListNum > 0 && allProfileList.length > 0"
								class="profiles-modal-overflow px-2 mb-2"
							>
								<div
									v-for="(profiles, index) in allProfileList"
									:key="index + 'resume'"
									class="d-flex align-items-center justify-content-between mt-2"
								>
									<div
										class="d-flex align-items-center justify-content-between profiles-blue-back pointer"
										@click="changeProfile(profiles._id)"
									>
										<div
											class="mb-resume-name d-flex align-items-center pointer"
										>
											<img
												v-if="profiles.primary"
												src="../../assets/New Profile/main-profile-icon2.svg"
												alt=""
											/>
											<img
												v-else
												class="mr-2"
												src="../../assets/New Profile/viewAll-resume-icon.svg"
												alt=""
											/>{{ profiles.profileName }}
										</div>
										<div
											v-if="profiles.draft && !profiles.primary"
											class="draft-box mr-2"
										>
											Draft
										</div>
									</div>
									<div class="d-flex align-items-center">
										<div
											v-if="!profiles.primary"
											class="asp-vertical-line mr-3"
										></div>
										<img
											v-if="!profiles.primary"
											class="pointer"
											@click.stop="
												$bvModal.show('deleteresume_1'),
													setProfileData(profiles.profileName, profiles._id)
											"
											v-b-tooltip.hover="'Delete'"
											src="../../assets/img/deleteprofile.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
							<div
								v-else
								class="resumes-sub-container-height mt-5 ml-3 text-center resumes-nodata-font"
							>
								No data found
							</div>
						</div>
					</div>
				</div>
			</b-modal>
		</template>
		<div class="create-profile-box" v-if="showModal && !isLaptop">
			<section class="h-100">
				<div class="profile-heading">
					<img
						@click="$emit('open-mob-create'), $emit('close-modal')"
						src="@/assets/newbuilder/backarw.svg"
						class="mr-1"
						alt=""
					/>
					Profiles
				</div>
				<div class="position-relative mt-2">
					<img
						class="resumes-search-image-position"
						src="@/assets/newdesign/assessPro/magni.svg"
						alt=""
					/>
					<b-form-input
						debounce="500"
						@update="getAllProfiles"
						v-model.trim="searchQuery"
						class="resumes-search-input w-100"
						placeholder="Search Profiles"
						type="search"
					>
					</b-form-input>
				</div>

				<div class="h-75 pr-1">
					<div
						style="position: relative; top: 50px"
						v-if="showProfileListLoader"
						class="d-flex justify-content-center align-items-center h-100"
					>
						<b-spinner label="Loading..."></b-spinner>
					</div>
					<div
						class="viewallprofs h-100 overflow-xh-ya mb-2"
						v-else-if="allProfileListNum > 0 && allProfileList.length > 0"
					>
						<div
							class="mt-2"
							v-for="(profiles, index) in allProfileList"
							:key="index + 'resume'"
						>
							<div
								class="d-flex align-items-center justify-content-between mt-2"
							>
								<div
									class="d-flex align-items-center justify-content-between profiles-blue-back pointer"
									@click="changeProfile(profiles._id)"
								>
									<div class="mb-resume-name d-flex align-items-center pointer">
										<img
											v-if="profiles.primary"
											src="@/assets/newbuilder/mob-primary.svg"
											alt=""
										/>
										<img
											v-else
											class="mr-2"
											src="@/assets/newbuilder/mob-profile.svg"
											alt=""
										/>{{ profiles.profileName }}
									</div>
									<div
										class="draft-box mr-2"
										v-if="profiles.draft && !profiles.primary"
									>
										Draft
									</div>
								</div>
								<div class="d-flex align-items-center">
									<div
										v-if="!profiles.primary"
										class="asp-vertical-line mr-3"
									></div>
									<img
										v-if="!profiles.primary"
										class="pointer"
										@click.stop="
											$bvModal.show('deleteresume_1'),
												setProfileData(profiles.profileName, profiles._id)
										"
										src="@/assets/newbuilder/mob-del.svg"
										alt=""
									/>
								</div>
							</div>
							<hr class="my-2" />
						</div>
					</div>
					<div
						v-else
						class="resumes-sub-container-height mt-5 ml-3 text-center resumes-nodata-font"
					>
						No data found
					</div>
				</div>
			</section>
		</div>
		<b-modal id="deleteresume_1" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div
						class="candash-modal-top no-border-bottom p-3 profiles-flex-column"
					>
						<div class="pro-width-10">
							<img
								src="../../assets/icons/candDashboard/modalDelete.svg"
								alt=""
							/>
						</div>
						<div class="pro-pl-3">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head pro-text-center">
									Delete Resume "{{ profileName }}"
								</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$bvModal.hide('deleteresume_1')"
								>
									<img
										class="rotate-on-hover"
										src="../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3 pro-text-center">
								Deleting the resume will delete your entire profile. This action
								cannot be undone?
							</div>
						</div>
					</div>

					<div class="d-flex align-items-center justify-content-end gap-4 p-3">
						<b-button
							class="candash-cancelBtn pro-w-50"
							@click="$bvModal.hide('deleteresume_1')"
							>Cancel</b-button
						>

						<div class="position-relative pro-w-50">
							<b-button
								class="candash-addBtn pro-w-100"
								@click="deleteNormalProfile()"
								:class="deleteOne ? 'loader-class-delete' : ''"
								>{{ deleteOne ? "" : "Delete" }}</b-button
							>
							<div v-if="deleteOne" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import {
	getAllProfiles,
	putNotification,
	deleteNormalProfile,
	switchProfile,
} from "../../utils/apiFunctions";
import { getProcessedToken } from "../../utils/request.js";
import Loader from "../fixedcomponents/Loader.vue";
import toast from "../mixin/toast";
export default {
	name: "Profiles",
	data() {
		return {
			allProfileList: [],
			allProfileListNum: null,
			showProfileListLoader: false,
			deleteOne: false,
			searchQuery: "",
			profileName: "",
			profileId: "",
			isDeletingResume: false,
		};
	},
	props: {
		showModal: Boolean,
		isLaptop: Boolean,
	},
	components: {
		Loader,
	},
	mixins: [toast],
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	created() {
		this.getAllProfiles();
	},
	methods: {
		async getAllProfiles() {
			this.showProfileListLoader = true;
			try {
				const res = await getAllProfiles(this.searchQuery);
				if (res.status == 200) {
					this.allProfileList = res.data.data.map((obj) => ({
						profileName: obj.profileName,
						_id: obj._id,
						draft: obj.draft,
						primary: obj.primary,
					}));

					this.allProfileListNum = this.allProfileList.length;
					this.$forceUpdate();
				} else {
					console.log("Api error");
				}
			} catch (error) {
				console.log(error);
			}
			this.showProfileListLoader = false;
		},
		async createNewProfile() {
			this.$emit("close-modal");
			this.allProfileListNum = null;
			this.viewAllResume = false;
			this.openDownload = false;
			this.$emit("show-create-new-profile");
			if (this.toggleNotification) {
				let payload = {
					userID: getProcessedToken(),
					notificationIDs: [this.notificationIDs],
				};
				const res = await putNotification(payload);
				if (res.status == 200) {
					this.$store.commit(
						"candidateVUEX/updatetogglecreateNewProfile",
						false
					);
				}
			}
		},
		changeProfile(id) {
			this.allProfileListNum = null;
			this.$emit("close-modal");
			this.$emit("change-profile", id);
			this.viewAllResume = false;
			this.openDownload = false;
			this.searchQuery = "";
		},
		setProfileData(name, id) {
			this.profileName = name;
			this.profileId = id;
			// this.$emit("close-modal");
		},
		checkGraphicalResumeDownload() {
			this.$emit("close-modal");
			this.$emit("downloadGraphicalResume");
		},
		openDownloadForm() {
			this.$emit("close-modal");
			this.$emit("checkDownloadForm");
		},
		async deleteNormalProfile() {
			this.deleteOne = true;
			this.isDeletingResume = true;
			try {
				const res = await deleteNormalProfile({
					id: this.profileId,
				});
				if (res.status === 200) {
					this.deleteOne = false;
					this.successModal(
						"Successfully deleted.",
						"Profile has been deleted."
					);
					let localCandidateInfo = (await switchProfile()).data.data;
					this.$store.commit(
						"candidateVUEX/setCandidateInfo",
						localCandidateInfo
					);
					this.$emit("change-profile", localCandidateInfo.primaryProfile.id);

					// location.reload();
					this.getAllProfiles();
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				console.log(error);
				this.errorModal("Error", "Something went wrong outside!");
			} finally {
				this.isDeletingResume = false;
				this.$bvModal.hide("deleteresume_1");
			}
		},
	},
};
</script>

<style>
@media only screen and (max-width: 1028px) {
	.viewallprofs::-webkit-scrollbar {
		width: 5px !important;
		height: 20px !important;
	}
	.viewallprofs::-webkit-scrollbar-thumb {
		border-radius: 15px !important;
		height: 30px !important;
		background: rgba(1, 83, 87, 0.32) !important;
		box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16) !important;
	}

	.viewallprofs::-webkit-scrollbar-track {
		background: var(--bg-white) !important;
		border-radius: 15px !important;
	}
}
</style>
